export function ajoutDevise(data) {
  return data + ' €';
}

export function formatDevise(data) {
  if (data === null || data === undefined) {
    return '';
  }
  const val = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(data);
  return val;
}
